var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoSmallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11459",
    "data-name": "Group 11459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.522,
    height: 15.526,
    viewBox: "0 0 15.522 15.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4158",
    "data-name": "Rectangle 4158",
    width: 15.522,
    height: 15.526,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11458",
    "data-name": "Group 11458",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M7.9,0A7.763,7.763,0,1,1,0,7.488,7.749,7.749,0,0,1,7.9,0m6.514,7.758a6.654,6.654,0,1,0-6.6,6.656,6.64,6.64,0,0,0,6.6-6.656",
    transform: "translate(0 -0.001)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M156.1,146.86c0-.612,0-1.224,0-1.836a.9.9,0,0,1,.036-.246.53.53,0,0,1,.573-.374.537.537,0,0,1,.469.481c.009.1.015.207.015.31q0,1.762,0,3.525a.879.879,0,0,1-.049.287.525.525,0,0,1-.569.342.537.537,0,0,1-.459-.481c-.01-.1-.016-.2-.016-.3,0-.569,0-1.137,0-1.706",
    transform: "translate(-148.886 -137.727)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M157.19,85.2c-.008.114-.01.226-.024.337a.536.536,0,0,1-.544.468.529.529,0,0,1-.518-.486,4.408,4.408,0,0,1-.015-.578.548.548,0,0,1,.421-.546.538.538,0,0,1,.654.444c.013.12.017.241.025.36",
    transform: "translate(-148.873 -80.483)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSmallIcon);
export default __webpack_public_path__ + "static/media/info-small-icon.bf035130818e41bb6b0c7b954a6d8e82.svg";
export { ForwardRef as ReactComponent };